import React, { lazy, Suspense, useEffect, useState } from 'react'
import { objectKeysToCamelCase } from 'Shared/helpers'
import SimpleLoader from 'Shared/SimpleLoader'
import getConfig from './Config'
import { triggerGtmEvent } from './GTM'
import { scriptLoader } from './Scripts'

const App = lazy(() => import('./App'))

let appConfig = {}

export const getAppConfig = () => {
  return appConfig
}

const AppWithConfig = (props) => {
  const [hasConfig, setHasConfig] = useState(false)

  useEffect(() => {
    const fetchConfig = () => {
      return new Promise((resolve) => {
        getConfig().then((conf) => {
          resolve(objectKeysToCamelCase(conf))
        })
      })
    }

    fetchConfig().then((conf) => {
      appConfig = conf
      setHasConfig(true)
    })
  }, [])

  useEffect(() => {
    if (hasConfig) {
      scriptLoader()
    }
  }, [hasConfig])

  useEffect(() => {
    if (hasConfig) {
      triggerGtmEvent()
    }
  }, [hasConfig])

  if (!hasConfig) return <SimpleLoader />

  return (
    <Suspense fallback={<SimpleLoader />}>
      <App {...props} />
    </Suspense>
  )
}

export default AppWithConfig
